import type { SVGProps } from 'react';

export const Reloading = (props: SVGProps<SVGSVGElement>) => (
    <svg width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' {...props}>
        <g fill='#000' fillRule='evenodd'>
            <path d='m23.63 13.883-1.81-2.304-.341-.434V11h-.114l-.781-.993-3.876 3.047 1.236 1.572 1.352-1.062C18.583 16.672 15.8 19 12.479 19a6.932 6.932 0 0 1-4.2-1.4l-.8-.6-1.201 1.599.799.6a8.92 8.92 0 0 0 5.402 1.8c4.25 0 7.814-2.965 8.752-6.933l.828 1.053 1.572-1.236ZM7.957 11.275 6.643 9.767l-1.034.902C6.233 7.444 9.074 5 12.478 5c1.53 0 2.982.483 4.2 1.4l.799.6 1.202-1.599-.8-.602A8.925 8.925 0 0 0 12.478 3c-4.525 0-8.27 3.36-8.897 7.715l-1.073-1.23L1 10.797l3.24 3.717 1.508-1.314 2.209-1.926Z' />
        </g>
    </svg>
);
